import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { omit } from 'helpers/object';

const INVALID_DOM_PROPS = ['creditPrice', 'handleScheduleAction', 'isLoggedIn', 'showReserveText'];

export const BaseCta = ({ children, className, classOptions, tag = 'a', tooltipProps = {}, ...otherProps }) => {
  const Tag = tag;

  return (
    <Tag
      className={classNames('bt bt--sm bt--text-sm schedule-item__cta tooltip tooltip--right', className, classOptions)}
      {...tooltipProps}
      {...omit(INVALID_DOM_PROPS, otherProps)}>
      {children}
    </Tag>
  );
};

BaseCta.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  classOptions: PropTypes.object,
  tag: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  tooltipProps: PropTypes.exact({
    'data-tooltip': PropTypes.string,
  }),
};
